const MasterClassIcon = () => {
  return (
    <path
      id='Vector'
      d='M24.651 3.29688H8.65104C7.18437 3.29688 5.98438 4.49688 5.98438 5.96354V27.2969C5.98438 28.7635 7.18437 29.9635 8.65104 29.9635H24.651C26.1177 29.9635 27.3177 28.7635 27.3177 27.2969V5.96354C27.3177 4.49688 26.1177 3.29688 24.651 3.29688ZM8.65104 5.96354H15.3177V16.6302L11.9844 14.6302L8.65104 16.6302V5.96354Z'
    />
  );
};

export default MasterClassIcon;
